var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-swipe',{staticClass:"number-swiper",attrs:{"vertical":"","autoplay":1500,"show-indicators":false}},_vm._l((_vm.dataList),function(item,index){return _c('van-swipe-item',{key:index},[_vm._v(_vm._s(item))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }